import { render, staticRenderFns } from "./modal.compoent.vue?vue&type=template&id=a0df4706&"
import script from "./modal.compoent.vue?vue&type=script&lang=js&"
export * from "./modal.compoent.vue?vue&type=script&lang=js&"
import style0 from "./modal.compoent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports